import React from 'react';

interface LoadingProps {
  text?: string;
  size?: 'sm' | 'md' | 'lg';
  fullHeight?: boolean;
  className?: string;
}

export const Loading: React.FC<LoadingProps> = ({
  text = 'Cargando...',
  size = 'md',
  fullHeight = false,
  className = '',
}) => {
  const sizeConfig = {
    sm: { spinner: 'w-5 h-5', text: 'text-sm', gap: 'gap-2' },
    md: { spinner: 'w-8 h-8', text: 'text-base', gap: 'gap-3' },
    lg: { spinner: 'w-12 h-12', text: 'text-lg', gap: 'gap-4' },
  };

  const config = sizeConfig[size];

  return (
    <div
      className={`
        flex flex-col items-center justify-center ${config.gap}
        ${fullHeight ? 'min-h-[400px]' : 'p-8'}
        ${className}
      `}
    >
      {/* Spinner */}
      <div className={`${config.spinner} relative`}>
        <div
          className="absolute inset-0 rounded-full border-2 border-slate-200"
        />
        <div
          className="absolute inset-0 rounded-full border-2 border-transparent border-t-primary-500 animate-spin"
        />
      </div>

      {/* Text with animated dots */}
      {text && (
        <div className={`${config.text} text-slate-500 flex items-center`}>
          <span>{text.replace('...', '')}</span>
          <span className="flex ml-0.5">
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                className="animate-bounce inline-block"
                style={{
                  animationDelay: `${i * 0.15}s`,
                  animationDuration: '0.6s',
                }}
              >
                .
              </span>
            ))}
          </span>
        </div>
      )}
    </div>
  );
};

// Versión compacta para tablas y listas
export const LoadingRow: React.FC<{ colSpan?: number; text?: string }> = ({
  colSpan = 1,
  text = 'Cargando...',
}) => (
  <tr>
    <td colSpan={colSpan} className="p-8">
      <Loading text={text} size="sm" />
    </td>
  </tr>
);

// Versión overlay para contenedores
export const LoadingOverlay: React.FC<{ text?: string }> = ({ text }) => (
  <div className="absolute inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-10 rounded-lg">
    <Loading text={text} />
  </div>
);
